import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { BookOpenIcon, PlusIcon } from '@heroicons/react/24/outline';

import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

import srcEdgeBoostDark from './components/edgeboost-dark.png';
import srcEdgeBoostLight from './components/edgeboost-light.png';

export default EdgeBoostPage;

export function EdgeBoost() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header
        title="Join EdgeBoost and get $250 RAS credit"
        Icon={BookOpenIcon}
        className="py-2 sm:hidden"
      />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-2xl space-y-8 pt-20 pb-10 text-center">
            <div className="space-y-8 rounded bg-gradient-to-br from-emerald-500/20 via-cyan-400/10 to-emerald-500/20 p-4 sm:p-8 dark:bg-white/5">
              <div className="mx-auto flex w-fit space-x-4">
                <Logo className="size-16 select-none sm:size-12" />
                <PlusIcon
                  className="h-auto w-6 shrink-0 text-zinc-500 dark:text-zinc-400"
                  aria-hidden="true"
                />
                <img
                  src={srcEdgeBoostLight}
                  alt="EdgeBoost logo"
                  title="EdgeBoost"
                  className="h-8 w-auto self-center dark:hidden"
                />
                <img
                  src={srcEdgeBoostDark}
                  alt="EdgeBoost logo"
                  title="EdgeBoost"
                  className="hidden h-8 w-auto self-center dark:inline-block"
                />
              </div>
              <h1 className="font-semibold text-xl text-zinc-900 tracking-tight sm:text-2xl dark:text-zinc-200">
                {typeof title === 'string' ? title : ''}
              </h1>
              <div className="p-4 text-center">
                <h4>
                  Sign up and use the referral code “RAS” to receive a $250 credit to use toward any
                  RAS service.
                </h4>
                <a
                  href="https://www.edgeboost.bet/guide?oid=308&affid=299"
                  target="_blank"
                  rel="noreferrer"
                  className="w-full sm:w-auto"
                >
                  <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                    <span>Join EdgeBoost</span>
                    <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                    <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                  </li>
                </a>
              </div>
            </div>
            {/* <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" /> */}
            <div className="text-left">
              <h4 className="mb-8">Offer terms & conditions</h4>
              <ul className="list-disc space-y-2 pl-4 text-xs text-zinc-500 dark:text-zinc-400">
                <li>New EdgeBoost users only.</li>
                <li>RAS's referral link or promo code must be used.</li>
                <li>
                  Deposit at least $500 into your EdgeBoost account and use it to make deposit at
                  any eligible sportsbook, DFS or sweepstakes site.
                </li>
                <li>
                  Contact RAS on{' '}
                  <a href="/support-chat" className="text-zinc-500" target="_self">
                    Support Chat
                  </a>
                  . You will be asked to forward us your EdgeBoost account confirmation email.
                </li>
                <li>
                  RAS will add $250 to your account balance which will automatically apply toward
                  your next RAS order. Promotional RAS balance is not redeemable for cash.
                </li>
              </ul>
            </div>
            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
          </div>
        </div>
        <div className="relative mt-8 px-4 sm:mt-0 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:text-emerald-500 hover:prose-a:text-emerald-600">
            <h3 className="mb-8">
              EdgeBoost is a financial platform designed for gaming, providing a bank account with a
              Visa debit card, helping players organize their bankroll, access higher limits, enjoy
              quicker withdrawals, and earn cashback &mdash; all without usage fees or minimums.
            </h3>
            <ul>
              <li>Up to $250k daily deposit limit, uncapped cash back</li>
              <li>Earn up to 0.5% cashback on qualifying sportsbook deposits. Terms apply.</li>
              <li>Live Customer Support Monday through Friday &mdash; 6 AM - 9 AM (EST)</li>
              <li>Avoid declined sportsbook/DFS deposits + enjoy faster deposits & withdrawals</li>
              <li>Keep gaming funds separate from everyday spending</li>
              <li>
                Accepted at online operators and brick-and-mortar casinos (safer than carrying cash)
              </li>
            </ul>

            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
            <div className="text-center">
              <h4>
                Sign up and use the referral code “RAS” to receive a $250 credit to use toward any
                RAS service.
              </h4>
              <a
                href="https://www.edgeboost.bet/guide?oid=308&affid=299"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto"
              >
                <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                  <span>Join EdgeBoost</span>
                  <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                  <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                </li>
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function EdgeBoostPage() {
  return <EdgeBoost />;
}
